<template>
  <div>
    <div class="login-header">
      <div class="sys-title" @click="toPage">
        <img class="block logoShow" src="@/assets/bule-zhe.png" />
        <div class="flex-crew">
          <div class="crew-title-one">船员</div>
          <div class="crew-title-two">船员,就上浙船员</div>
        </div>
      </div>
      <div>
        <div class="fl login-in">
          <span @click="toLogin" style="cursor: pointer">登录</span>
        </div>
      </div>
    </div>
    <div class="login-content">
      <div class="login-user">
        <el-tabs v-model="activeName" class="user-tabs" stretch>
          <el-tab-pane label="个人注册" name="first">
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              label-width="7.1429rem"
              class="demo-ruleForm"
            >
              <el-form-item label="用户名" prop="loginName">
                <el-input
                  v-model="ruleForm.loginName"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="cellphoneNo">
                <el-input
                  v-model="ruleForm.cellphoneNo"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="短信验证码"
                prop="msgCode"
                class="phone-mess"
              >
                <el-input v-model="ruleForm.msgCode"></el-input>
                <div
                  v-if="userTrue && phoneTrue && !isCountingDown"
                  class="phone-code green-code"
                  @click="getPhoneCode"
                >
                  获取验证码
                </div>
                <div
                  v-else-if="isCountingDown"
                  disabled
                  class="phone-code gray-code"
                >
                  {{ countdownSeconds }} 秒后重发
                </div>
                <div v-else class="phone-code gray-code">获取验证码</div>
              </el-form-item>
              <el-form-item label="输入密码" prop="plainPassword">
                <el-input
                  type="password"
                  v-model="ruleForm.plainPassword"
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="confirmPasword">
                <el-input
                  type="password"
                  v-model="ruleForm.confirmPasword"
                ></el-input>
              </el-form-item>
              <el-form-item label="图片验证码" prop="imageVerifyCode">
                <el-input v-model="ruleForm.imageVerifyCode"></el-input>
                <img
                  v-bind:src="codeSrc"
                  alt
                  class="code-image"
                  @click="getCode"
                />
              </el-form-item>
              <!-- <div style="line-height: 1.6857rem; height: 1.6857rem">
                <input
                  type="checkbox"
                  id="accept"
                  v-model="ruleForm.isAgreement"
                  class="accept-check fl"
                />
                <div class="fl">同意并遵守</div>
                <div class="fl"><a href="">《蓝水母平台服务条款》</a></div>
              </div> -->
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                class="login-button2"
                >注册</el-button
              >
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  login,
  checkPhoneIsRegister,
  sendCellPhoneNoCode,
  userRegister,
  ckLoginName,
} from "@/apis/index";
import { MD5 } from "@/utils/md5.js";
import { apiRoot } from "@/config";
export default {
  name: "LoginList",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      activeName: "first",
      ruleForm: {},
      rules: {
        loginName: [{ validator: this.validateUser, trigger: "blur" }],
        cellphoneNo: [{ validator: this.validateMobile, trigger: "blur" }],
        msgCode: [{ validator: this.validateMsCode, trigger: "blur" }],
        plainPassword: [{ validator: this.validatePass, trigger: "blur" }],
        confirmPasword: [
          { validator: this.validateCheckPass, trigger: "blur" },
        ],
        imageVerifyCode: [{ validator: this.validateImage, trigger: "blur" }],
      },
      userTrue: false,
      phoneTrue: false,
      codeSrc: "",
      isCountingDown: false,
      countdownSeconds: 60,
      timerId: null, // 计时器id
    };
  },
  created() {
    this.test = process.env.NODE_ENV;
    this.url = process.env.VUE_APP_BASE_URL;
  },
  mounted() {
    this.getCode();
  },
  methods: {
    async login() {
      await login({
        loginName: "jstzmsa",
        plainPassword: "1F02F43B7E431F941262EB09268F53BA",
      });
    },
    //获取图片验证码
    async getCode() {
      this.codeSrc = apiRoot + "/user/getVerify?a=" + Math.random();
    },
    //获取手机验证码
    async getPhoneCode() {
      await sendCellPhoneNoCode({
        cellphoneNo: this.ruleForm.cellphoneNo,
      });
      this.isCountingDown = true;
      this.countdownSeconds = 60; // 重置倒计时剩余秒数
      this.timerId = setInterval(() => {
        if (this.countdownSeconds > 0) {
          this.countdownSeconds--;
        } else {
          this.isCountingDown = false;
          clearInterval(this.timerId);
        }
      }, 1000);
    },
    //手机号
    async validateMobile(rule, value, callback) {
      if (!value) {
        this.phoneTrue = false;
        return callback(new Error("手机号不能为空"));
      } else if (!/^1[356789][0-9]{9}$/.test(value)) {
        this.phoneTrue = false;
        return callback(new Error("请输入正确的手机号"));
      } else {
        const res = await checkPhoneIsRegister({
          cellphoneNo: value,
        });
        if (res.code == 0) {
          return callback(new Error("该手机号已被注册"));
        } else {
          this.phoneTrue = true;
          callback();
        }
      }
    },
    // 用户户名
    async validateUser(rule, value, callback) {
      if (!value) {
        this.userTrue = false;
        return callback(new Error("用户名不能为空"));
      } else if (!/^[a-z][a-zA-Z0-9_-]{5,16}$/.test(value)) {
        this.userTrue = false;
        return callback(
          new Error(
            "请按照要求填写账号: 6 到16位(小写字母开头,数字,下划线,减号)"
          )
        );
      } else {
        const res = await ckLoginName({ id: value });
        if (res == true) {
          return callback(new Error("该用户名已被注册"));
        } else {
          this.userTrue = true;
          callback();
        }
      }
    },
    //验证码
    validateMsCode(rule, value, callback) {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      } else if (!/^[^\u4e00-\u9fa5]+$/.test(value)) {
        return callback(new Error("不能包含汉字"));
      } else {
        callback();
      }
    },
    //密码
    validatePass(rule, value, callback) {
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else if (!/^\S{6,16}$/.test(value)) {
        return callback(new Error("请按照要求填写密码: 6 到16位"));
      } else {
        callback();
      }
    },
    //二次输入密码
    validateCheckPass(rule, value, callback) {
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else if (!/^\S{6,16}$/.test(value)) {
        return callback(new Error("请按照要求填写密码: 6 到16位"));
      } else if (value != this.ruleForm.plainPassword) {
        return callback(new Error("与上面密码输入不一致"));
      } else {
        callback();
      }
    },
    //验证码图片
    validateImage(rule, value, callback) {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      } else {
        callback();
      }
    },
    //注册
    async register() {
      // try {
      const res = await userRegister({
        cellphoneNo: this.ruleForm.cellphoneNo,
        confirmPasword: MD5(this.ruleForm.confirmPasword),
        // encryptedConfig: MD5(this.ruleForm.encryptedConfig),
        imageVerifyCode: this.ruleForm.imageVerifyCode,
        isAgreement: true,
        loginName: this.ruleForm.loginName,
        msgCode: this.ruleForm.msgCode,
        plainPassword: MD5(this.ruleForm.plainPassword),
      });
      // console.log(res);
      if (!res.code) {
        this.$message({
          message: res.msg,
          type: "warning",
        });
        // throw new Error("请求失败，请稍候重试。"); // 抛出错误信息
      } else if (res.code == 1) {
        this.$message({
          message: "注册成功",
          type: "success",
        });
        this.$router.push("/login");
      }
      // const data = await res.json(); // 解析响应数据并返回
      // return data;
      // } catch (error) {
      //   console.error(error); // 输出错误信息到控制台
      //   throw error; // 将错误信息继续向外抛出
      // }
    },
    //登录
    toLogin() {
      this.$router.push("/login");
    },
    //注册
    toReset() {
      this.$router.push("/register");
    },
    toPage() {
      this.$router.push("/home");
    },
    //注册
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.register();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// h3 {
//   margin: 40px 0 0;
// }
// ul {
//   list-style-type: none;
//   padding: 0;
// }
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
// a {
//   color: #42b983;
// }
</style>
